"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaaangggSettings = exports.ApiError = exports.Baaanggg = void 0;
const AuthAPI_1 = require("./api/AuthAPI");
const Constant = require("./Constant");
const AdminAPI_1 = require("./api/AdminAPI");
const MeAPI_1 = require("./api/MeAPI");
const ChainAPI_1 = require("./api/ChainAPI");
const APIRequester_1 = require("./APIRequester");
const CoinAPI_1 = require("./api/CoinAPI");
const CollectionAPI_1 = require("./api/CollectionAPI");
const UserAPI_1 = require("./api/UserAPI");
const ItemAPI_1 = require("./api/ItemAPI");
const TransactionAPI_1 = require("./api/TransactionAPI");
const LinkAPI_1 = require("./api/LinkAPI");
class Baaanggg {
    constructor(url, settings) {
        this.url = url;
        this.settings = settings;
        this.requester = new APIRequester_1.APIRequester(this.url, {
            getToken: () => this.getToken(),
            onAuthenticated: (token) => this.setToken(token),
            requestAuthCallback: () => __awaiter(this, void 0, void 0, function* () {
                if (this.settings.requestAuthCallback) {
                    yield this.settings.requestAuthCallback();
                    return Promise.resolve();
                }
                return Promise.reject("No callback");
            })
        });
        this.auth = new AuthAPI_1.AuthAPI(this.requester, token => this.setToken(token));
        this.admin = new AdminAPI_1.AdminAPI(this.requester);
        this.me = new MeAPI_1.MeAPI(this.requester);
        this.chain = new ChainAPI_1.ChainAPI(this.requester);
        this.coin = new CoinAPI_1.CoinAPI(this.requester);
        this.collection = new CollectionAPI_1.CollectionAPI(this.requester);
        this.user = new UserAPI_1.UserAPI(this.requester);
        this.item = new ItemAPI_1.ItemAPI(this.requester);
        this.transaction = new TransactionAPI_1.TransactionAPI(this.requester);
        this.link = new LinkAPI_1.LinkAPI(this.requester);
    }
    static local(settings) {
        return new Baaanggg(Constant.LOCAL_URL, settings);
    }
    setToken(token) {
        var _a;
        this.token = token;
        if ((_a = this.settings) === null || _a === void 0 ? void 0 : _a.useLocalStorage)
            localStorage.setItem('token', JSON.stringify(token));
    }
    getToken() {
        var _a;
        let token = this.token;
        if ((_a = this.settings) === null || _a === void 0 ? void 0 : _a.useLocalStorage) {
            const tokenJson = localStorage.getItem('token');
            if (tokenJson != null)
                token = JSON.parse(tokenJson);
        }
        return token;
    }
}
exports.Baaanggg = Baaanggg;
class ApiError extends Error {
    constructor(response) {
        super(response.message);
    }
}
exports.ApiError = ApiError;
class BaaangggSettings {
    constructor() {
        this.useLocalStorage = false;
    }
}
exports.BaaangggSettings = BaaangggSettings;
